import * as React from 'react'
import { BlockType, isReferenceBlock } from '@basehub/data/replicache/index'
import { useWorkingTreeStore } from './blocks-tree/provider'

export const useBlockReferences = ({ blockId }: { blockId: string }) => {
  const getNode = useWorkingTreeStore((s) => s.tree?.getNode)
  const blocksByType = useWorkingTreeStore(
    (s) =>
      // new Map so that this is reactive
      new Map(
        (s.tree?.compoundIndexes.get('blocksByType') as
          | Map<BlockType, Set<string>>
          | undefined) ?? new Map()
      ) as Map<BlockType, Set<string>>
  )

  return React.useMemo(() => {
    if (!getNode) return []
    const filtered = []
    for (const refId of (blocksByType.get('reference') ?? new Set()).values()) {
      const node = getNode(refId)
      if (!node) continue
      if (
        isReferenceBlock(node.value) &&
        node.value.value.targetBlockIds?.includes(blockId)
      ) {
        const copy = { ...node }
        filtered.push(copy)
      }
    }
    return filtered
  }, [blockId, getNode, blocksByType])
}
